import { Reducer as FormMetaReducer } from 'modules/Forms/FormMeta'

export const FormsSagas = []

export const FormsReducers = {
  'forms/meta': FormMetaReducer,
}
